import { useTranslation } from 'next-i18next'
import { type ReactNode } from 'react'
import { useTheme } from 'styled-components'

import { TRANSLATION_KEYS } from '@/constants/localization'
import {
  RichCardImageOverlayContainer,
  RichCardImageOverlayDescription,
  RichCardImageOverlayTitle,
  RichCardImageOverlayWrapper,
} from '@/features/listing/components/rich-card/styled'
import { Badge, BadgeSize } from '@/ui/atoms/badge/Badge'

type RichCardImageOverlayProps = {
  title?: string | ReactNode
  description?: string | null
  showViewMore?: boolean
}

export const RichCardImageOverlay = ({
  title,
  description,
  showViewMore,
}: RichCardImageOverlayProps) => {
  const { t } = useTranslation([TRANSLATION_KEYS.LISTING])
  const { colors } = useTheme()

  // if there is no title or description, we don't need to show the overlay
  if (!title && !description) return null

  return (
    <RichCardImageOverlayContainer data-testid="rich-card-image-overlay">
      <RichCardImageOverlayWrapper>
        <div>
          {title && (
            <RichCardImageOverlayTitle weight="bold" color={colors.white} forwardedAs="h4">
              {title}
            </RichCardImageOverlayTitle>
          )}
          {description && (
            <RichCardImageOverlayDescription size="xSmall" color={colors.white}>
              {description}
            </RichCardImageOverlayDescription>
          )}
        </div>
        {showViewMore && (
          <Badge
            size={BadgeSize.XLARGE}
            backgroundColor="transparent"
            color={colors.white}
            borderColor={colors.white}
            label={t('listing:rich_card.view_more')}
          />
        )}
      </RichCardImageOverlayWrapper>
    </RichCardImageOverlayContainer>
  )
}
